export default __webpack_public_path__ + "static/cool-2-07024e4e5f77bdabd8a2fed87cf8a2d3.svg";